import { Parenthood, SubjectData } from 'shell/models/person';
import { ParentVM } from 'civil-status/view-models/step-form';
import { transformerGenerality } from './transformer-generality';

export const transformerParent = (parenthood?: Parenthood): ParentVM | undefined => {
  if (!Boolean(parenthood?.generalita)) {
    return undefined;
  }

  const subjectLike = {
    generalita: parenthood?.generalita,
    statoCivile: parenthood?.statoCivile,
    cittadinanza: parenthood?.cittadinanza ? [parenthood.cittadinanza] : undefined,
    altriDati: parenthood?.altriDati,
  } as SubjectData;

  const fiscalCode = parenthood?.generalita?.codiceFiscale?.codFiscale;

  return {
    searchPerson: fiscalCode ? { fiscalCode } : undefined,
    generality: transformerGenerality(subjectLike),
  };
};
